// Import React library
import React from 'react'; 
import PropTypes from 'prop-types';
// To connect to store 
import { connect } from 'react-redux';
// Reselect to observe the recomputation  
//import { createStructuredSelector } from 'reselect';
import { selectProjectModel } from '../../selectors/ProjectSpecifics';
import { selectedAddress, duplexAddress } from '../../selectors/ServiceAddress';
import StepNavButtons from '../Sections/StepNavButtons';
import WorkSiteContact from '../Sections/ProjectSpecifics/WorkSiteContact';
import MeterLocation from '../Sections/ProjectSpecifics/MeterLocation';
import BuildingFootage from '../Sections/ProjectSpecifics/BuildingFootage';
import GasAppliances from '../Sections/ProjectSpecifics/GasAppliances';
import GasDeliveryPressure from '../Sections/ProjectSpecifics/GasDeliveryPressure';
import Obstacles from '../Sections/ProjectSpecifics/Obstacles';
import * as consts from '../../constants';
import util from '../../lib/util';
import { nextStepClicked } from '../../actions';
import YesNoOptions from '../Sections/YesNoOptions';

class ProjectSpecifics extends React.Component {
  constructor() {
    super();
    this.state = { nextStepSuccess: false };
  }
  componentWillReceiveProps(p) {
    if (p.project && p.project.isSuccess && !this.state.nextStepSuccess) {
      this.setState({ nextStepSuccess: true });
      if (p.project.isRouteToDashboard) {
        util.trackGoogleAnalytics(p.pageName, 'Project Saved', 'Project Saved in Dashboard');
        util.routeToDashbord(p);
      }
      else {
        if (p.project.skipSchedule) {
          util.trackGoogleAnalytics(p.pageName, 'Project Offramped', 'Project Offramped Schedule Skipped');
        }
        let nextStep = p.project.skipSchedule ? 5 : 4;
        if (p.isLoggedIn)
          nextStep = nextStep - 1;
        if (p.pageName == consts.NEW_GAS_LINE_NAME)
          nextStep++;//new gas line has one more step other than other products
        p.onNextStepClicked(nextStep);
      }
    }
  }
  onSaveClick() {
    let model = this.props.projectModel;
    model.stepName = "dashboard";
    this.saveProject(model);
  }
  onNextClick() {
    let model = this.props.projectModel;
    model.stepName = "step5_projectspecifics";
    this.saveProject(model);
  }
  saveProject(model) {
    this.setState({ nextStepSuccess: false });
    const p = this.props;
    let validators = [];
    if (p.isDifferentContactSelected) {
      validators = [

        ['workSiteContactName', p => p.workSiteContactName, "Name"],
        ['workSiteContactPhone', p => p.workSiteContactPhone, window.osa.lookup.projectSpecifics.workSiteContactPhone],
        ['workSiteContactPhone', p => !p.workSiteContactPhone || util.isPhoneValid(p.workSiteContactPhone), `#${window.osa.lookup.projectSpecifics.workSiteContactPhone} is invalid`],
        ['workSiteCellPhone', p => !p.workSiteCellPhone || util.isPhoneValid(p.workSiteCellPhone), `#${window.osa.lookup.projectSpecifics.workSiteCellPhone} is invalid`]
      ];
    }
    if (p.pageName == consts.NEW_GAS_LINE_NAME) {
      validators.push(['meterLocation', p => p.meterLocation, "Meter location"]);
    }
    if (p.pageName == consts.SERVICE_REMOVAL_NAME) {
      validators.push(['Built1990', p => p.Built1990, "Was the building built before 1990?"]);
      validators.push(['WillActiveConstruction', p => p.WillActiveConstruction, "Will work be in progress on the building or debris from work be present while FortisBC personnel are on site?"]);
    }

    if (util.validate(validators, p, p.formError)) {
      p.saveProject(model);
    }
  }
  onBackClick() {
    this.setState({ nextStepSuccess: false });
    const p = this.props;
    if (!p.isLoggedIn && p.verifyAccountRetriesExceed) {
      let backStep = p.pageName == consts.NEW_GAS_LINE_NAME ? 2 : 1;
      p.onNextStepClicked(backStep);
    }
    else
      this.props.onBackClick();
  }
  render() {
    const p = this.props;
    const lookup = window.osa.lookup;
    const options = [
      {
        "id": "1",
        "title": "Was the building built before 1990?",
        "name": "Built1990"
      }
    ];
    const options1 = [
      {
        "id": "1",
        "title": "Do you have a Hazardous Materials Report?",
        "name": "HazardousMaterialsReport"
      }
    ];

    const options2 = [
      {
        "id": "1",
        "title": "Will work be in progress on the building or debris from work be present while FortisBC personnel are on site?",
        "name": "WillActiveConstruction"
      }
    ];
    if (!lookup) return null;
    return (
      <div>
        <WorkSiteContact isDifferentContactSelected={p.isDifferentContactSelected} />
        {p.pageName == consts.NEW_GAS_LINE_NAME ?
          <div>
            <MeterLocation />
            <BuildingFootage isDuplex={p.isTwoMeter} address={p.address1} />
            <GasAppliances isDuplex={p.isTwoMeter} address={p.address1} />
            {
              p.isTwoMeter ?
                <div>
                  <BuildingFootage isDuplex address={p.address2} nameExt="2" />
                  <GasAppliances isDuplex address={p.address2} nameExt="2" />
                </div>
                : null
            }
            <GasDeliveryPressure address={p.address1} />
            <Obstacles />
          </div>
          :
          <div>
            <YesNoOptions items={options} required={true} />
            <p>If "Yes" to building built before 1990,</p>
            <YesNoOptions items={options2} required={true}  />
            <YesNoOptions items={options1} />
            
            <p><strong>WorkSafeBC regulations dictates we are unable to enter your site without a Hazardous Materials Report.</strong></p>
            <p><strong>Please forward a copy of the Hazardous Materials Report to  <a href="mailto:gasservice@fortisbc.com" >gasservice@fortisbc.com</a> within 5 business days. In the subject line please include the project number. Failure to send the report will result in cancellation of the project.</strong></p>
          </div>
        }
        <StepNavButtons text="Next step" onNextClick={() => this.onNextClick()} onBackClick={() => this.onBackClick()} isShowSave={p.isLoggedIn} onSaveClick={() => this.onSaveClick()} onCancelClick={() => p.onCancelClick()} />
      </div>
    );
  }
}
ProjectSpecifics.propTypes = {
  id: PropTypes.string.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isDifferentContactSelected: PropTypes.bool,
  workSiteContactName: PropTypes.string,
  Built1990: PropTypes.string,
  WillActiveConstruction: PropTypes.string,
  HazardousMaterialsReport: PropTypes.string,
  workSiteContactPhone: PropTypes.string,
  workSiteCellPhone: PropTypes.string,
  workSiteContactPosition: PropTypes.string,
  projectModel: PropTypes.object,
  project: PropTypes.object,
  form: PropTypes.object
};

function mapDispatchToProps(dispatch) {
  return {
    onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    saveProject: (model) => dispatch({ type: 'SAVE_PROJECT', model }),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error })
  };
}

function mapStateToProps(state) {
  return {
    form: state.form,
    isDifferentContactSelected: (state.form.workSiteContact && state.form.workSiteContact == 2),
    workSiteContactName: state.form.workSiteContactName,
    Built1990: state.form.Built1990,
    WillActiveConstruction: state.form.WillActiveConstruction,
    HazardousMaterialsReport: state.form.HazardousMaterialsReport,
    workSiteContactPhone: state.form.workSiteContactPhone,
    workSiteCellPhone: state.form.workSiteCellPhone,
    workSiteContactPosition: state.form.workSiteContactPosition,
    project: state.gas.project,
    projectModel: selectProjectModel(state),
    differentDeliveryPressure: state.form.differentDeliveryPressure,
    pageName: state.gas.pageName,
    meterLocation: state.form.meterLocation,
    isTwoMeter: state.form.buildingType == "2" && state.form.duplexMeterCount == "2",
    address1: util.addressToString(selectedAddress(state)),
    address2: util.addressToString(duplexAddress(state)),
    verifyAccountRetriesExceed: state.gas.verifyAccountExceed
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectSpecifics);